import { useMedia } from '@landsbankinn/ui';
import * as React from 'react';
import { StickyFirstColumn } from '../../shared/MarketsComponents';
import { FundDataType } from '../Funds';

interface IProps {
  fundDataType: FundDataType;
  children: React.ReactNode;
}

export function FundsTableContainer({ fundDataType, children }: IProps) {
  const isMobile = useMedia('sm');

  return (
    <>
      {isMobile && fundDataType === FundDataType.Price ? (
        <StickyFirstColumn>
          <>{children}</>
        </StickyFirstColumn>
      ) : (
        <>{children}</>
      )}
    </>
  );
}
